const utils = require('frontend-controller/lib/utils');

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'table'
	],

	config: {
		isSortable: false,
		supportLazyloading: false,
		buttonContext: 'shippingOrders',
		renderEmptyBeforReady: false,
		showHead: true,
		showInsertButton: true,
		showColorCodedRows: true,
		showAllBorders: true,
		showDelimiterBorders: true,
		inline: true,
		// maxNrOfExportElements: 500000,
		// privilegeBase: 'nl_mailings',
		rowActionsProperties: {
			colWidth: '45px',
		// 	colSpan: 1,
		// 	rowSpan: 2
		},
		// customColActionsFile: 'templates/newsletter/mailings/table/customColActions',

		rowActions: {
		// 	delete: true,
		// // 	edit: true,
			customs: [{
				buttonType: 'showReplace',
				icon: 'fi fi-shippingOrder-showReplace',
				inline: true,
				// buttonContext: 'shippingOrder'
			}]
		},
		addRowClassViaAttribute: [
			{
				fieldCode:  'isReplaceable',
				value:      true,
				class:      'isReplaceable',
			},
			{
				fieldCode:  'isCanceled',
				value:      true,
				class:      'isCanceled',
			},
		],

		// autoInsertWhenEmpty: false, // if one opens up this table and there are no data to be shown, then this is an employee trying to create a shippingOrder.
		heartbeatRefreshOn: {
			'reconnect': true,
			// 'resourceChanged.all': true,
			// 'resourceChanged.bo_projects': true,
			// // 'resourceChanged.bo_customers': true,
			// // 'resourceChanged.bo_employees': true,
			// 'resourceChanged.bo_projectTerms': true,
			// 'resourceChanged.bo_projectTermJobs': true,
			// 'resourceChanged.bo_projectTermJobStatus': true,
			// // 'resourceChanged.bo_customerContacts': true,
			'resourceChanged.bo_shippingOrders': true,
		},
	},

	model: {
		projectID: null, // actual projectID
		projectTermID: null, // actual projectTermID
	},

	methods: {

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
			resourceFilters = resourceFilters || {}
			const resourceRegister = this.getResourceRegisterContent('shippingOrdersTable') || {}
			const parentResourceFilters = resourceRegister.resourceFilters || {}
			const projectTerm = resourceRegister.projectTerm || {}

			this.model.projectID = parentResourceFilters.projectID
			this.model.projectTermID = parentResourceFilters.projectTermID

			this.config.showInsertButton = !!this.model.projectTermID && !projectTerm.hasShippingOrder && !!projectTerm.isLastProjectsTermInShippingOrderGroup

			utils.refReplace(resourceFilters, parentResourceFilters)
		},

		showInsert(buttonContext, buttonMode){
			let result

			if(buttonContext === 'shippingOrders'){
				if(this.model.projectTermID){
					this.closest('templates_crew_projects_viewer', viewer => {
						result = viewer.showEdit('timeRecordings', 'shippingOrder', this.model.projectID, this.model.projectTermID, undefined, undefined, 'shippingOrderTable', true)
							.then(() => {
								this.refreshData(true)
							})
							// TODO: IMPL
							// .fail(() => {
							// 	console.log('SHIPPING ORDER TABLE ABORT')
							// })
					})
				} else {
					this.performAction(
						this.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'projects.crewViewer.insertShippingOrderWithoutProjectTermContext.message'
							}
						}, {
							statusControllerLoadingMessage: '',
							statusControllerSavingMessage:  ''
						})
					)
				}
			}

			return result || utils.promise.resolve()
		},

		async showReplace(rowID, rowData){
			let result = utils.promise.resolve()
			const isReplaceable = !!((rowData || {}).attributes || {}).isReplaceable

			if(rowID){
				// prevent shippingOrder replacement after it has been already billed or replaced
				if(!isReplaceable){
					await this.performAction(this.prepareAction('message', undefined, {
						messageDisplay: {
							message: 'error:shippingOrder.notAbleToReplaceShippingOrder'
						}
					}))
					return result
				}

				// ensure that the user knows what he / she is doing
				const decisionContext = await this.performDecision(
					'confirm',
					{
						component:  this,
						title:      storage.__('projects.crewViewer.replaceShippingOrderHint.title'),
						message:    storage.__('projects.crewViewer.replaceShippingOrderHint.message'),
					}
				) || {}
				const decision = decisionContext.decision || {}
				if(decision.type !== 'yes'){
					return result
				}

				// replace shippingOrder
				this.closest('templates_crew_projects_viewer', viewer => {
					result = viewer.showEdit('timeRecordings', 'shippingOrder', this.model.projectID, this.model.projectTermID, undefined, undefined, 'shippingOrderTable', true, {
						replaceShippingOrderID: rowID
					})
						.then(() => {
							this.refreshData(true)
						})
						// TODO: IMPL
						// .fail(() => {
						// 	console.log('SHIPPING ORDER TABLE ABORT')
						// })
				})
			}

			return result
		},

		// onResourceSanitized(){
		// 	if(this.config.autoInsertWhenEmpty && utils.isEmpty(this.resourceData.data)){
		// 		this.config.autoInsertWhenEmpty = false
		// 		this.showInsert('shippingOrders')
		// 	}
		// },

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID) {
				if(rowData.attributes.url){
					// MARK: WINDOW_OPEN_VS_A_HREF
					// TODO: there is no good reason why the signature field does not work properly if a shipping order gets opened via window.open instead of an a href.
					// but i cannot change the fact that it is.
					// window.open(rowData.attributes.url, '_blank')
					$(`<a href="${rowData.attributes.url}" target="_blank">Test</a>`)[0].click()
				}
			}
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers = this.config.heartbeatRefreshOn || {}
			const key = message.heartbeatKey

			if(refreshers[key] && (
				key !== 'resourceChanged.bo_shippingOrders' ||
				message.data.projectID == this.model.projectID
			)){
				this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
			}
		},
	},

	// hooks: {
	// 	attach($element, options){
	// 		if(!options.refresh){
	// 			this.parent('')
	// 		}
	// 	},
	// },
}
